import React, { Component } from 'react';
import LandingPage from './Components/LandingPage';
// import ProjectsList from './Components/ProjectsList';
import 'sanitize.css';
import './App.css';
// import PROJECTS from './data';

class App extends Component {
  render() {
    return (
      <div className="app">
        <LandingPage
          pointRadius={1}
          pointFillColor={'#FFC300'}
          pointStrokeColor={'#FFC300'}
          lineStrokeColor={'rgba(255,192,0,0.1)'}
          canvasBgColor={'#fff'}
        >
        </LandingPage>
        <div className="introSec">
          <h1 className="intro">Hi, I'm Yanpu.</h1>
          <h3 >I'm a design-minded full-stack web developer.
            I'm passionate in building scalable and user friendly applications with pixel accurate interface!
          </h3>
        </div>
        {/* <div className="project-section">
          <h2>Side Projects</h2>
          <ProjectsList
            projects={PROJECTS}
          />
        </div> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js